var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconinvalid(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.13765 6.00083L11.7019 1.43658C11.8728 1.2899 11.9748 1.07971 11.9832 0.855176C11.9922 0.630621 11.9068 0.412125 11.748 0.253357C11.5893 0.0945873 11.3708 0.00915698 11.1462 0.0182344C10.9217 0.0265508 10.7115 0.128617 10.5648 0.299479L6.00055 4.86374L1.4363 0.299479C1.11574 0.0250279 0.639418 0.0439376 0.341547 0.341818C0.0436564 0.639708 0.024766 1.11601 0.299208 1.43657L4.86347 6.00082L0.299208 10.5651C-0.0137985 10.8796 -0.0137985 11.3877 0.299208 11.7022C0.613724 12.0152 1.12179 12.0152 1.4363 11.7022L6.00056 7.13792L10.5648 11.7022C10.8793 12.0152 11.3874 12.0152 11.7019 11.7022C12.0149 11.3877 12.0149 10.8796 11.7019 10.5651L7.13765 6.00083Z",
    fill: "#ED4B37"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconinvalid);
export default __webpack_public_path__ + "static/media/icon.invalid.11d57be38dace43a3e85668e90811634.svg";
export { ForwardRef as ReactComponent };